<template>
  <div class="row mb-1">
    <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 px-gap">
      <div class="widget-12 card card-default widget-loader-circle shade">
        <div class="card-body">
          <div class="row">
            <div id="stasiun-tv" class="col-md-4">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <div class="pull-left m-t-5 m-b-5">
                    <h4 class="m-b-0">Stasiun TV</h4>
                    <p class="small hint-text">Daftar Stasiun TV</p>
                  </div>
                  <div class="pull-right">
                    <div class="form-check form-check-inline switch m-t-20">
                      <input
                        type="checkbox"
                        v-model="show_grafik_pie"
                        id="pie-stasiun"
                      />
                      <label for="pie-stasiun">Tampilkan Grafik</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <loader-component v-if="is_loading" />
                  <div v-else>
                    <div
                      v-if="Object.keys(data.table).length === 0"
                      class="alert alert-danger"
                      role="alert"
                      align="center"
                    >
                      <strong>Mohon maaf, data tidak tersedia! </strong>
                      <br />
                      Tidak dapat menampilkan grafik dengan data kosong.
                    </div>
                    <div v-else>
                      <table-dynamic-component
                        v-if="!show_grafik_pie"
                        :data_head="data.table.dt_head"
                        :data_body="data_body"
                        :data_head_class="data_head_class"
                        :config="data.table.dt_config"
                        table_class="table-stripped"
                        table_id="tv-table"
                      />
                      <div v-else>
                        <pie-chart-component
                          :data="data_pie"
                          :config="config_pie"
                          :height="450"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="grafik-stasiun" class="col-md-8">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <div class="pull-left m-t-5 m-b-5">
                    <h4 class="m-b-0">Data Stasiun TV</h4>
                    <p class="small hint-text">Data Tren Stasiun TV</p>
                  </div>
                  <div class="pull-right">
                    <div
                      class="form-check form-check-inline switch m-t-20 m-b-0"
                    >
                      <input
                        type="checkbox"
                        v-model="show_grafik_tv"
                        id="pagesSwitchTv"
                      />
                      <label for="pagesSwitchTv">Tampilkan Grafik Bar</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <loader-component v-if="is_loading" />
                  <div v-else>
                    <div
                      v-if="Object.keys(data.grafik.y).length < 1"
                      class="alert alert-danger"
                      role="alert"
                      align="center"
                    >
                      <strong> Mohon maaf, data tidak tersedia! </strong>
                      <br />
                      Tidak dapat menampilkan grafik dengan data kosong.
                    </div>
                    <div v-else>
                      <line-chart-component
                        v-if="!show_grafik_tv"
                        :series="data.grafik"
                        el="tren-tv"
                        :height="400"
                      />
                      <dynamic-chart-component
                        v-else-if="show_grafik_tv"
                        :config="configTren"
                        chart_id="garfik-tv"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "@/views/components/loader.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";
import line_chart from "@/views/components/chart/line_chart.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import dynamic_chart from "@/views/components/chart/dynamic_chart.vue";
export default {
  name: "medkon_stasiun_tv",
  props: {
    is_loading: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    data: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      show_grafik_tv: false,
      show_grafik_pie: false,
      data_pie: [],
      configTren: null,
      config_pie: {
        align: "center",
        height: 300,
        itemWidth: 130,
      },
      data_body: [],
      data_head_class: [
        {
          head: "Jumlah",
          class: "text-center",
        },
      ],
    };
  },
  components: {
    "loader-component": loader,
    "table-dynamic-component": table_dynamic,
    "line-chart-component": line_chart,
    "pie-chart-component": pie_chart,
    "dynamic-chart-component": dynamic_chart,
  },
  methods: {
    assemblePieChart() {
      if (
        this.data &&
        this.data.table &&
        Object.keys(this.data.table).length > 0
      ) {
        for (let i = 0; i < this.data.table.dt_body.length; i++) {
          this.data_pie.push({
            name: this.data.table.dt_body[i][0],
            y: this.data.table.dt_body[i][1],
          });
        }
      }
    },
    assembleJurnalisTable() {
      if (this.data && this.data.table) {
        this.data.table.dt_body.forEach((el) => {
          this.data_body.push([el[0], `<center>${el[1]}</center>`]);
        });
      }
    },
  },
  created: function() {
    this.assembleJurnalisTable();
    this.assemblePieChart();
    if (this.data) {
      let valueDataX = [];
      for (let i in this.data.grafik.x) {
        let sumY = 0;
        for (let val in this.data.grafik.y) {
          sumY += this.data.grafik.y[val]["data"][i];
        }
        valueDataX.push(sumY);
      }
      this.configTren = {
        chart: {
          type: "column",
          backgroundColor: "transparent",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: this.data.grafik.x,
        },
        yAxis: {
          title: {
            text: "Berita",
          },
          min: 0,
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
            },
          },
        },
        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat: "Total: {point.y}",
        },
        series: [{ showInLegend: false, data: valueDataX }],
      };
    }
  },
};
</script>
